export default "__VITE_ASSET__b6e7ca7e__"